import Popup from "../Controls/Popup";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { removeTags } from "@utils/tools";
import isEmpty from "is-empty";

type SeeMoreProps = {
  content: string;
  defaultOpen: boolean;
  limit: number;
  btnElement: (opened: boolean, toggle: () => void) => JSX.Element;
  popupTitle: string;
};

const SeeMore: React.FC<SeeMoreProps> = ({
  defaultOpen = false,
  content,
  limit,
  btnElement,
  popupTitle,
}) => {
  const [show, setShow] = useState<boolean>(defaultOpen);

  const toggle = () => {
    setShow(!show);
  };

  const getSize = () => {
    //on recup le content sans les tags html;
    let text = removeTags(content);
    //on split le content en nombre de . qu'il y a
    let size = text.split(".").length;
    //si la phrase est splitté en plusieurs morceaux
    if (size > 0) {
      let subtext = text.split(".")[1];
      //verifier si le morceau suivant est vide ou pas, si vide, size === 1
      if (isEmpty(subtext)) {
        size = 1;
      }
    }
    return size;
  };

  const getShortContent = () => {
    let text = removeTags(content);
    text = `${text.split(".")[0]}.`;
    return text;
  };

  const getContent = () => {
    return removeTags(content);
  };

  return (
    <>
      <div className="tw-hidden md:tw-block tw-w-full tw-overflow-auto tw-font-montserrat">
        {!show ? (
          <>
            {getSize() === 1 ? (
              <>
                <div dangerouslySetInnerHTML={{ __html: getContent() }}></div>
              </>
            ) : (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: getShortContent(),
                  }}
                ></div>
                <div className="tw-hidden md:tw-block tw-font-montserrat">
                  {btnElement(show, toggle)}
                </div>
                <div className="tw-block md:tw-hidden">
                  <Popup
                    title={popupTitle}
                    btnElement={(onClick) => btnElement(false, onClick)}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: getContent() }}
                    ></div>
                  </Popup>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <div dangerouslySetInnerHTML={{ __html: getContent() }}></div>
            {btnElement(show, toggle)}
          </>
        )}
      </div>
      {getContent().length > 0 && (
        <div className="tw-block md:tw-hidden">
          <Popup
            title={popupTitle}
            btnElement={(onClick) => btnElement(false, onClick)}
          >
            <div dangerouslySetInnerHTML={{ __html: getContent() }}></div>
          </Popup>
        </div>
      )}
    </>
  );
};

SeeMore.propTypes = {
  //
};

export default SeeMore;
